module.exports = __webpack_public_path__ + "img/p23.16bcc7d4.jpg";